'use client'
import { usePathname } from 'next/navigation'
import type { ReactNode } from 'react'
/** Embed authority is supplied by its host; Clerk cookies are neither needed nor inherited. */
export function EmbedAwareIdentity({
  children,
  appContent,
}: {
  children: ReactNode
  appContent: ReactNode
}) {
  const pathname = usePathname()
  if (pathname?.startsWith('/embed/')) {
    return children
  }
  // The server composes Clerk's provider and client slots. Importing that tree
  // here pulls its transitive dependencies into every route's client graph.
  return appContent
}
